exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bezel[data-v-45f0ea34]{display:flex;flex-direction:row;flex-wrap:wrap}.bezel-box[data-v-45f0ea34]{min-width:464px;padding:0 0 0 10px;margin-right:20px;margin-bottom:20px;border:1px solid #bfcbd9;border-radius:10px;display:flex;flex-direction:column}.bezel-close[data-v-45f0ea34]{width:44px;height:34px;margin-top:-17px;margin-right:-27px;align-self:flex-end;background-color:hsla(0,0%,100%,0);border-color:hsla(0,0%,100%,0)}.bezel-list[data-v-45f0ea34]{margin-top:10px;display:flex;flex-direction:row;align-items:center}.bezel-item[data-v-45f0ea34]{margin-right:10px;position:relative}.bezel-label[data-v-45f0ea34]{position:absolute;top:120px;width:142px;text-align:center;display:inline-block}.bezel-tips[data-v-45f0ea34]{display:flex;justify-content:center}.background-img-content[data-v-45f0ea34]{width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-45f0ea34&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/BottomButton.vue
// module id = 513
// module chunks = 0